<template>
<div >

	<Loader :show="saving"></Loader>

	<b-form @submit.prevent="save" v-if="!loading" novalidate >
		
		<Upload 
			v-model="form.logo" 
			:invalid="validation.hasError('form.logo.id')"
			placeholder="Logo"
			:multiple="false"
		></Upload>

		<b-form-group label="Marca" >
			<b-form-input
				v-model="form.title"
				placeholder="Marca"
				:state="!validation.hasError('form.title')" 
			></b-form-input>
			<b-form-invalid-feedback>Ingrese un nombre válido</b-form-invalid-feedback>
		</b-form-group>


		<h6 class="mt-4 mb-2">Modelos</h6>
		<div class="d-flex mb-2" v-for="(model, index) in form.models" :key="index">
			<div class="" style="width:calc(100% - 50px)">
				<b-form-group>
					<b-form-input
						v-model="model.title"
						placeholder="Modelo"
					></b-form-input>
				</b-form-group>
			</div>
			<div class="" style="width:50px; margin-left:4px;">
				<div class="btn btn-xs btn-light" @click="removeModel(index)">x</div>
			</div>
		</div>
		<div class="btn btn-light btn-sm" @click="addModel()">Agregar modelo</div>

		<div class="overflow-hidden mt-3">
			<b-button type="submit" class="pull-right" size="sm" variant="primary">Guardar cambios</b-button>
		</div>
		
		<b-button type="button" @click="deletePrompt" block v-if="action=='update'" variant="outline-danger" class="btn-delete mt-4">Eliminar marca</b-button>
		
	</b-form>
	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import Upload from '@/components/Upload'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'BrandForm',
	mixins:[mixins],
	props:['id'],
	components:{
		Loader,
		Upload
	},
	data () {
		return {
			action: 'create',
			form: {
				title: null,
				logo:{
					id: null
				},
				models: [],
			},
			loading: true,
			saving: false,
		}
	},
	validators: {
		'form.logo.id': function (value) {
			return Validator.value(value).required();
		},
		'form.title': function (value) {
			return Validator.value(value).required();
		},	
	},
	beforeMount(){
		if(this.id > 0){
			this.action = 'update'
			this.load(this.id)
		}else{
			this.loading = false
		}
	},
	methods: {
		load(id){
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					car_brand (id: $id) {
						id
						title
						models{
							id
							title
						}
						logo{
							id
							filename
							url
							urlThumb
							type
							size
						}
					}
				}`,
				variables: {
					id
				},
			})
			.then((data) => {
				const brand = data.data.car_brand;
				this.form = {
					...brand,
					models: brand.models || [],
					logo: brand.logo || { id: null },
				};
				this.loading = false
				this.$emit('loaded')
			});
		},
		checkValidation() {
			return this.$validate()
			.then(function (success) {
				if (success) {
					return true
				}
				return false
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				var models = []
				;(this.form.models || []).forEach(model => {
					models.push({id:model.id,title:model.title})
				})
				let dataInput = {
					title 			: this.form.title,
					models 			: models,
					logo_file_id	: this.form.logo.id
				}
				
				if(this.action == 'create' ){
					this.create(dataInput)
				}else
				if(this.action == 'update' ){
					this.update(this.form.id, dataInput)
				}
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:CarBrandInput! ){
					carBrandCreate( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.$emit('updated')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
		update (id, data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID!, $data:CarBrandInput! ){
					carBrandUpdate( id: $id, data: $data) {
						id
					}
				}`,
				variables: {
					id: id,
					data: data,
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.$emit('updated')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
		deletePrompt() {
			this.$dialog
			.confirm('¿Está seguro que desea suspender este cliente?')
			.then(() => {
				this.delete()
			})
		},
		delete() {
			this.$apollo.mutate({
				mutation: gql`mutation ( $id: ID! ){
					carBrandDelete( id: $id) {
						id
					}
				}`,
				variables: {
					id: this.form.id,
				}
			})
			.then(() => {
				this.$toast.success('Elemento eliminado correctamente')
				this.$emit('updated')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
		addModel(){
			this.form.models.push({})
		},
		removeModel(index){
			this.form.models.splice(index,1)
		},

	}
}


</script>
